import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "./BuyPlan.css";
import useRegistration from "../../services/LandingPage/useGetStarted";
import Logo from "../../images/MY-Anlook.png";
import formImage from "../../images/LandingPageImage/anlook_login_img_1.webp";
import megaphone from "../../images/LandingPageImage/megaphone.svg";
import megaphone1 from "../../images/LandingPageImage/megaphone (1).svg";
import megaphone2 from "../../images/LandingPageImage/megaphone (2).svg";
import megaphone3 from "../../images/LandingPageImage/megaphone (3).svg";
import greentick from "../../images/LandingPageImage/greentickfeature.svg";
import infoIcon from "../../images/LandingPageImage/info-circle.svg";
import usePlans from "../../services/LandingPage/usePlans";

const GetStarted = () => {
  const { registerUser, verifyOTP } = useRegistration();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showTrialForm, setShowTrialForm] = useState(false);
  const [showBuyPlanDetails, setshowBuyPlanDetails] = useState(false);
  const [showBuyPlanForm, setShowBuyPlanForm] = useState(false);

  const { plans, loading, refetch: fetchSubscriptionPlans } = usePlans("IN");

  const openTrialForm = () => {
    setShowTrialForm(true);
    setshowBuyPlanDetails(false);
  };

  // Function to handle the "Continue" button click
  const openBuyPlanDetails = () => {
    if (selectedPlan) {
      setshowBuyPlanDetails(true);
      setShowBuyPlanForm(false);
      setShowTrialForm(false);
    } else {
    }
  };

  const closeBuyPlanDetails = () => {
    setShowTrialForm(false);
    setShowBuyPlanForm(false);
    setshowBuyPlanDetails(false);
  };

  const openBuyPlanForm = () => {
    setShowBuyPlanForm(true);
    setshowBuyPlanDetails(false);
    setShowTrialForm(false);
  };

  const handlePlanSelect = (planData) => {
    // Directly store the entire plan object in the selectedPlan state
    setSelectedPlan(planData);
  };

  // ################## Free Trail Registration ##################################
  const [freetrialformData, setFreetrialformData] = useState({
    firstName: "",
    lastName: "",
    countryCode: "+91",
    mobileNo: "",
    emailId: "",
    dob: "",
    gender: "",
    password: "",
    confirmPassword: "",
    otp: "",
  });
  const [freetrialformErrors, setFreetrialformErrors] = useState({});
  const [freetrialformStep, setFreetrialformStep] = useState(1);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleFreetrialformChange = (e) => {
    const { name, value } = e.target;
    setFreetrialformData({ ...freetrialformData, [name]: value });
    // Clear error for the current field on change
    setFreetrialformErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const toggleShowConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const validateFreetrialform = () => {
    const errors = {};
    // Validation for Step 1
    if (freetrialformStep === 1) {
      if (!freetrialformData.firstName) {
        errors.firstName = "First Name is required";
        setFreetrialformErrors(errors);
        toast.error("First Name is required");
        return;
      }

      if (!freetrialformData.lastName) {
        errors.lastName = "Last Name is required";
        setFreetrialformErrors(errors);
        toast.error("Last Name is required");
        return;
      }

      if (!freetrialformData.emailId) {
        errors.emailId = "Email is required";
        setFreetrialformErrors(errors);
        toast.error("Email is required");
        return;
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
          freetrialformData.emailId,
        )
      ) {
        errors.emailId = "Invalid email address";
        setFreetrialformErrors(errors);
        toast.error("Invalid email address");
        return;
      }

      if (!freetrialformData.countryCode) {
        errors.countryCode = "Country code is required";
        setFreetrialformErrors(errors);
        toast.error("Country code is required");
        return;
      }

      if (!freetrialformData.mobileNo) {
        errors.mobileNo = "Mobile number is required";
        setFreetrialformErrors(errors);
        toast.error("Mobile number is required");
        return;
      } else if (!/^\d{10}$/.test(freetrialformData.mobileNo)) {
        errors.mobileNo = "Invalid mobile number. Must be 10 digits.";
        setFreetrialformErrors(errors);
        toast.error("Invalid mobile number. Must be 10 digits.");
        return;
      }

      if (!freetrialformData.dob) {
        errors.dob = "Date of Birth is required";
        setFreetrialformErrors(errors);
        toast.error("Date of Birth is required");
        return;
      }

      if (!freetrialformData.gender) {
        errors.gender = "Gender is required";
        setFreetrialformErrors(errors);
        toast.error("Gender is required");
        return;
      }
    }

    // Validation for Step 2
    else if (freetrialformStep === 2) {
      if (!freetrialformData.password) {
        errors.password = "Password is required";
        setFreetrialformErrors(errors);
        toast.error("Password is required");
        return;
      } else if (freetrialformData.password.length < 6) {
        errors.password = "Password must be at least 6 characters long";
        setFreetrialformErrors(errors);
        toast.error("Password must be at least 6 characters long");
        return;
      }

      if (!freetrialformData.confirmPassword) {
        errors.confirmPassword = "Confirm Password is required";
        setFreetrialformErrors(errors);
        toast.error("Confirm Password is required");
        return;
      } else if (
        freetrialformData.password !== freetrialformData.confirmPassword
      ) {
        errors.confirmPassword = "Passwords do not match";
        setFreetrialformErrors(errors);
        toast.error("Passwords do not match");
        return;
      }
    }

    setFreetrialformErrors(errors);

    if (Object.keys(errors).length > 0) {
      toast.error("Please fix the highlighted errors.");
    }

    return Object.keys(errors).length === 0;
  };

  const handleFreetrialformContinue = async (e) => {
    e.preventDefault();

    if (validateFreetrialform()) {
      if (freetrialformStep === 1) {
        setFreetrialformStep(2);
      } else {
        const requestBody = {
          firstName: freetrialformData.firstName,
          lastName: freetrialformData.lastName,
          countryCode: freetrialformData.countryCode,
          mobileNo: freetrialformData.mobileNo,
          emailId: freetrialformData.emailId,
          dob: freetrialformData.dob,
          gender: freetrialformData.gender,
          password: freetrialformData.password,
          isTrial: "true",
        };

        try {
          const response = await registerUser(requestBody);

          if (response.responseCode === "00") {
            toast.success(response.responseMessage);
            setFreetrialformStep(3);
          } else {
            toast.error(
              response.responseMessage || "Failed to create trial account.",
            );
          }
        } catch (error) {
          toast.error("Failed to create trial account.");
        }
      }
    }
  };

  const handleFreetrialformBack = () => setFreetrialformStep(1);

  const clearFreetrialForm = () => {
    setFreetrialformData({
      firstName: "",
      lastName: "",
      countryCode: "+91",
      mobileNo: "",
      emailId: "",
      dob: "",
      gender: "",
      password: "",
      confirmPassword: "",
    });
    setFreetrialformErrors({});
    setFreetrialformStep(1);
    setShowConfirmPassword(false);
  };

  // Step 3: New OTP verification function
  const handleOTPVerificationFreeTrail = async (e) => {
    e.preventDefault();

    if (!freetrialformData.otp) {
      setFreetrialformErrors((prev) => ({
        ...prev,
        otp: "OTP is required",
      }));
      toast.error("OTP is required");
      return;
    }

    try {
      const response = await verifyOTP({
        otp: freetrialformData.otp,
        mobile: freetrialformData.mobileNo,
      });

      if (response.responseCode === "00") {
        clearFreetrialForm();
        const token = response.response;

        window.location.href = `https://www.anlook.com/identity?accessToken=${token}`;
      } else {
        toast.error(response.responseMessage || "Invalid OTP");
      }
    } catch {
      toast.error("OTP verification failed");
    }
  };

  // ##################### Buy Plan Registration #########################
  const [buyplanFormData, setBuyplanFormData] = useState({
    buyplanFirstName: "",
    buyplanLastName: "",
    buyplanEmail: "",
    countryCode: "+91",
    mobileNo: "",
    buyplanDob: "",
    buyplanGender: "",
    buyplanPassword: "",
    buyplanConfirmPassword: "",
  });
  const [buyplanFormErrors, setBuyplanFormErrors] = useState({});
  const [buyplanFormStep, setBuyplanFormStep] = useState(1);
  // const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleBuyplanInputChange = (e) => {
    const { name, value } = e.target;
    setBuyplanFormData({ ...buyplanFormData, [name]: value });

    setBuyplanFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  // const toggleShowConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);

  const validateBuyplanForm = () => {
    const errors = {};

    // Validation for Step 1
    if (buyplanFormStep === 1) {
      if (!buyplanFormData.buyplanFirstName) {
        errors.buyplanFirstName = "First Name is required";
        setBuyplanFormErrors(errors);
        toast.error("First Name is required");
        return;
      }

      if (!buyplanFormData.buyplanLastName) {
        errors.buyplanLastName = "Last Name is required";
        setBuyplanFormErrors(errors);
        toast.error("Last Name is required");
        return;
      }

      if (!buyplanFormData.buyplanEmail) {
        errors.buyplanEmail = "Email is required";
        setBuyplanFormErrors(errors);
        toast.error("Email is required");
        return;
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
          buyplanFormData.buyplanEmail,
        )
      ) {
        errors.buyplanEmail = "Invalid email address";
        setBuyplanFormErrors(errors);
        toast.error("Invalid email address");
        return;
      }

      if (!buyplanFormData.countryCode) {
        errors.countryCode = "Country code is required";
        setBuyplanFormErrors(errors);
        toast.error("Country code is required");
        return;
      }

      if (!buyplanFormData.mobileNo) {
        errors.mobileNo = "Mobile number is required";
        setBuyplanFormErrors(errors);
        toast.error("Mobile number is required");
        return;
      } else if (!/^\d{10}$/.test(buyplanFormData.mobileNo)) {
        errors.mobileNo = "Invalid mobile number. Must be 10 digits.";
        setBuyplanFormErrors(errors);
        toast.error("Invalid mobile number. Must be 10 digits.");
        return;
      }

      if (!buyplanFormData.buyplanDob) {
        errors.buyplanDob = "Date of Birth is required";
        setBuyplanFormErrors(errors);
        toast.error("Date of Birth is required");
        return;
      }

      if (!buyplanFormData.buyplanGender) {
        errors.buyplanGender = "Gender is required";
        setBuyplanFormErrors(errors);
        toast.error("Gender is required");
        return;
      }
    }

    // Validation for Step 2
    else if (buyplanFormStep === 2) {
      if (!buyplanFormData.buyplanPassword) {
        errors.buyplanPassword = "Password is required";
        setBuyplanFormErrors(errors);
        toast.error("Password is required");
        return;
      } else if (buyplanFormData.buyplanPassword.length < 6) {
        errors.buyplanPassword = "Password must be at least 6 characters long";
        setBuyplanFormErrors(errors);
        toast.error("Password must be at least 6 characters long");
        return;
      }

      if (!buyplanFormData.buyplanConfirmPassword) {
        errors.buyplanConfirmPassword = "Confirm Password is required";
        setBuyplanFormErrors(errors);
        toast.error("Confirm Password is required");
        return;
      } else if (
        buyplanFormData.buyplanPassword !==
        buyplanFormData.buyplanConfirmPassword
      ) {
        errors.buyplanConfirmPassword = "Passwords do not match";
        setBuyplanFormErrors(errors);
        toast.error("Passwords do not match");
        return;
      }
    }

    setBuyplanFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      toast.error("Please fix the highlighted errors.");
    }

    return Object.keys(errors).length === 0;
  };

  const handleBuyplanFormContinue = async (e) => {
    e.preventDefault();

    if (validateBuyplanForm()) {
      if (buyplanFormStep === 1) {
        setBuyplanFormStep(2);
      } else if (buyplanFormStep === 2) {
        const requestBody = {
          firstName: buyplanFormData.buyplanFirstName,
          lastName: buyplanFormData.buyplanLastName,
          countryCode: buyplanFormData.countryCode,
          mobileNo: buyplanFormData.mobileNo,
          emailId: buyplanFormData.buyplanEmail,
          dob: buyplanFormData.buyplanDob,
          gender: buyplanFormData.buyplanGender,
          password: buyplanFormData.buyplanPassword,
          isTrial: "false",
        };

        try {
          const response = await registerUser(requestBody);

          if (response.responseCode === "00") {
            toast.success(response.responseMessage);
            setBuyplanFormStep(3);
          } else {
            toast.error(response.responseMessage || "Failed to purchase plan.");
          }
        } catch (error) {
          toast.error("Failed to purchase plan.");
        }
      }
    }
  };

  const handleBuyplanFormBack = () => setBuyplanFormStep(1);

  const clearForm = () => {
    setBuyplanFormData({
      buyplanFirstName: "",
      buyplanLastName: "",
      buyplanEmail: "",
      countryCode: "+91",
      mobileNo: "",
      buyplanDob: "",
      buyplanGender: "",
      buyplanPassword: "",
      buyplanConfirmPassword: "",
    });
    setBuyplanFormErrors({});
    setBuyplanFormStep(1); // Reset step to 1 if needed
  };

  // Step 3: New OTP verification function
  const handleOTPVerification = async () => {
    if (!buyplanFormData.otp) {
      setBuyplanFormErrors((prev) => ({
        ...prev,
        otp: "OTP is required",
      }));
      toast.error("OTP is required");
      return;
    }

    try {
      const response = await verifyOTP({
        otp: buyplanFormData.otp,
        mobile: buyplanFormData.mobileNo,
      });

      if (response.responseCode === "00") {
        clearForm();
        const token = response.response;
        const callbackUrl = "https://www.anlook.com/identity";

        window.location.href = `${callbackUrl}?accessToken=${token}`;
      } else {
        toast.error(response.responseMessage || "Invalid OTP");
      }
    } catch {
      toast.error("OTP verification failed");
    }
  };

  useEffect(() => {
    fetchSubscriptionPlans();
  }, [fetchSubscriptionPlans]);

  return (
    <>
    <ToastContainer/>
 
    <div className="vh-100 min-h-screen">

      {/* Main Screen Buy Plan */}
      {!showTrialForm && !showBuyPlanDetails && !showBuyPlanForm && (
        <div className="buyplan-content flex flex-col lg:flex-row w-full min-h-screen justify-center">
          {/* Left Section */}
          <div className="buyplan-left-section w-full lg:w-1/2 bg-black flex items-center">
            <div className="px-6 py-8 lg:p-16 w-full">
              <div className="pb-8">
                <img
                  className="My-logo nav-landing-logo h-10"
                  src={Logo}
                  alt="logo"
                />
              </div>

              <h3 className="buyplan-welcome text-white text-lg font-semibold">
                WELCOME TO ANLOOK!
              </h3>

              <h2 className="buyplan-title text-2xl font-semibold text-white mt-2">
                Select your Plan
              </h2>

              <p className="buyplan-description text-gray-300 mt-4">
                So How Does the 15-Day Free Trial Work?
                <br />
                You can use Anlook free for up to 15 Days, with full access to
                everything offered on the plan you sign up for. If you don’t
                cancel within 15 days, we’ll charge you for the plan you
                selected.
              </p>

              <button
                className="buyplan-btn buyplan-btn-trial mt-6 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg transition"
                onClick={openTrialForm}
              >
                Start Free 15-Day Trial
              </button>

              <p className=" text-gray-800 mt-10">
                You can upgrade, downgrade, or cancel at any time with just a
                few clicks.
              </p>
            </div>
          </div>

          {/* Right Section */}
          <div className="buyplan-right-section w-full lg:w-1/2 flex items-center bg-white">
            <div className="px-6 py-8 lg:p-16 w-full">
              <h3 className="buyplan-existing-title text-xl font-semibold mb-6">
                OR You Can Choose From Our Existing Plan
              </h3>

              <div className="space-y-4">
                {loading && <p>Loading plans...</p>}
                {Array.isArray(plans) &&
                  plans.map((planItem) => (
                    <div
                      key={planItem.id}
                      className="buyplan-plan-option border rounded-lg p-4 cursor-pointer hover:shadow-md transition"
                      onClick={() => handlePlanSelect(planItem)}
                    >
                      <div className="flex items-start gap-3 w-full">
                        <input
                          type="radio"
                          name="plan"
                          checked={selectedPlan?.id === planItem.id}
                          onChange={() => handlePlanSelect(planItem)}
                          className="mt-1"
                        />

                        <div className="flex justify-between w-full">
                          {/* Left Content */}
                          <div className="pr-4">
                            <h4 className="buyplan-plan-name font-semibold text-lg">
                              {planItem.plan_name}
                            </h4>
                            <p className="buyplan-plan-description text-gray-600 mt-2">
                              {planItem.plan_desc}
                            </p>
                          </div>

                          {/* Price */}
                          <div className="text-right whitespace-nowrap">
                            <span className="buyplan-price font-semibold text-black text-lg">
                              ₹ {parseFloat(planItem.plan_price).toFixed(2)}/mo.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>

              <button
                className="buyplan-btn buyplan-btn-continue mt-6 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg transition disabled:opacity-50"
                onClick={openBuyPlanDetails}
                disabled={!selectedPlan}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Free Traial Screen */}
      {showTrialForm && !showBuyPlanDetails && (
        <div className="buyplan-content flex flex-col lg:flex-row w-full min-h-screen justify-center">
          {/* LEFT SECTION */}
          <div className="buyplan-left-section w-full lg:w-1/2 bg-black flex items-center">
            <div className="w-full px-6 py-8 lg:p-16">
              <h2 className="buyplan-trial-title text-gray-900 text-2xl font-semibold mb-6">
                Get started with a Trial Account on{" "}
                <span className="buyplan-logo font-bold">Anlook</span>
              </h2>

              <form className="buyplan-trial-form space-y-4">
                {/* STEP 1 */}
                {freetrialformStep === 1 && (
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {/* First Name */}
                    <div>
                      <label className="buyplan-label text-gray-900 text-sm">
                        First Name
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        value={freetrialformData.firstName}
                        onChange={handleFreetrialformChange}
                        className="buyplan-input w-full mt-1 px-3 py-2 rounded-md border border-gray-300 focus:ring-2 focus:ring-green-500 outline-none"
                      />
                    </div>

                    {/* Last Name */}
                    <div>
                      <label className="buyplan-label text-gray-900 text-sm">
                        Last Name
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        value={freetrialformData.lastName}
                        onChange={handleFreetrialformChange}
                        className="buyplan-input w-full mt-1 px-3 py-2 rounded-md border border-gray-300 focus:ring-2 focus:ring-green-500 outline-none"
                      />
                    </div>

                    {/* Email */}
                    <div className="lg:col-span-2">
                      <label className="buyplan-label text-gray-900 text-sm">
                        Business Email
                      </label>
                      <input
                        type="email"
                        name="emailId"
                        value={freetrialformData.emailId}
                        onChange={handleFreetrialformChange}
                        className="buyplan-input w-full mt-1 px-3 py-2 rounded-md border border-gray-300 focus:ring-2 focus:ring-green-500 outline-none"
                      />
                    </div>

                    {/* Country Code */}
                    <div>
                      <label className="buyplan-label text-gray-900 text-sm">
                        Country
                      </label>
                      <select
                        name="countryCode"
                        value={freetrialformData.countryCode}
                        onChange={handleFreetrialformChange}
                        className="buyplan-input w-full mt-1 px-3 py-2 rounded-md border border-gray-300"
                      >
                        <option value="+91">+91</option>
                        <option value="+1">+1</option>
                      </select>
                    </div>

                    {/* Mobile */}
                    <div>
                      <label className="buyplan-label text-gray-900 text-sm">
                        Phone Number
                      </label>
                      <input
                        type="text"
                        name="mobileNo"
                        value={freetrialformData.mobileNo}
                        onChange={handleFreetrialformChange}
                        className="buyplan-input w-full mt-1 px-3 py-2 rounded-md border border-gray-300"
                      />
                    </div>

                    {/* DOB */}
                    <div>
                      <label className="buyplan-label text-gray-900 text-sm">
                        Date of Birth
                      </label>
                      <input
                        type="date"
                        name="dob"
                        value={freetrialformData.dob}
                        onChange={handleFreetrialformChange}
                        className="buyplan-input w-full mt-1 px-3 py-2 rounded-md border border-gray-300"
                      />
                    </div>

                    {/* Gender */}
                    <div>
                      <label className="buyplan-label text-gray-900 text-sm">
                        Gender
                      </label>
                      <select
                        name="gender"
                        value={freetrialformData.gender}
                        onChange={handleFreetrialformChange}
                        className="buyplan-input w-full mt-1 px-3 py-2 rounded-md border border-gray-300"
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                )}

                {/* STEP 2 */}
                {freetrialformStep === 2 && (
                  <div className="space-y-4">
                    <h4 className="text-white text-lg font-medium">
                      Set up your password
                    </h4>

                    <input
                      type="password"
                      name="password"
                      placeholder="Password"
                      value={freetrialformData.password}
                      onChange={handleFreetrialformChange}
                      className="buyplan-input w-full px-3 py-2 rounded-md border border-gray-300"
                    />

                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      placeholder="Confirm Password"
                      value={freetrialformData.confirmPassword}
                      onChange={handleFreetrialformChange}
                      className="buyplan-input w-full px-3 py-2 rounded-md border border-gray-300"
                    />

                    <div className="flex items-center gap-2 text-white text-sm">
                      <input
                        type="checkbox"
                        checked={showConfirmPassword}
                        onChange={toggleShowConfirmPassword}
                      />
                      Show Password
                    </div>
                  </div>
                )}

                {/* STEP 3 */}
                {freetrialformStep === 3 && (
                  <div className="space-y-4">
                    <h4 className="text-white text-lg font-medium">
                      OTP Verification
                    </h4>

                    <div className="text-gray-300 text-sm">
                      OTP has been Sent to {freetrialformData.mobileNo}
                    </div>

                    <input
                      type="text"
                      name="otp"
                      placeholder="Enter OTP"
                      value={freetrialformData.otp}
                      onChange={handleFreetrialformChange}
                      className="buyplan-input w-full px-3 py-2 rounded-md border border-gray-300"
                    />

                    <button
                      onClick={handleOTPVerificationFreeTrail}
                      className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-md transition"
                    >
                      Verify OTP
                    </button>
                  </div>
                )}

                {/* BUTTON SECTION */}
                <div className="flex gap-3 pt-4">
                  {freetrialformStep === 2 && (
                    <button
                      onClick={handleFreetrialformBack}
                      className="bg-gray-500 hover:bg-gray-600 text-white px-5 py-2 rounded-md"
                    >
                      Back
                    </button>
                  )}

                  {freetrialformStep !== 3 && (
                    <button
                      onClick={handleFreetrialformContinue}
                      className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-md"
                    >
                      {freetrialformStep === 1 ? "Continue" : "Send OTP"}
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>

          {/* RIGHT SECTION */}
          <div className="buyplanTrailSection-rightSection w-full lg:w-1/2 bg-white flex items-center">
            <div className="w-full px-6 py-8 lg:p-16">
              <img
                className="My-logo nav-landing-logo h-10 mb-6"
                src={Logo}
                alt="logo"
              />

              <h1 className="buyplanTrailSection-heroTitle text-3xl font-bold mb-6">
                Unlock the Full Potential of Your Business with{" "}
                <span className="text-green-600">WhatsApp</span>
              </h1>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div>
                    <div className="flex items-center gap-2 font-semibold text-green-600 mb-2">
                      <img src={megaphone} className="h-10" alt="" />
                      Targeted Campaigns
                    </div>
                    <p className="text-gray-600 text-sm">
                      Deliver personalized offers that drive results
                    </p>
                  </div>

                  <div>
                    <div className="flex items-center gap-2 font-semibold text-green-600 mb-2">
                      <img src={megaphone1} className="h-10" alt="" />
                      Ready-to-Use Templates
                    </div>
                    <p className="text-gray-600 text-sm">
                      Send timely updates and reminders
                    </p>
                  </div>

                  <div>
                    <div className="flex items-center gap-2 font-semibold text-green-600 mb-2">
                      <img src={megaphone2} className="h-10" alt="" />
                      24/7 Instant Engagement
                    </div>
                    <p className="text-gray-600 text-sm">
                      Keep your customers connected with no-code chatbots
                    </p>
                  </div>

                  <div>
                    <div className="flex items-center gap-2 font-semibold text-green-600 mb-2">
                      <img src={megaphone3} className="h-10" alt="" />
                      Product Catalogue
                    </div>
                    <p className="text-gray-600 text-sm">
                      Quickly send catalogues to multiple customers, boosting
                      your sales.
                    </p>
                  </div>
                </div>

                <div className="flex items-center justify-center">
                  <img src={formImage} className="w-full max-w-xl" alt="" />
                </div>
              </div>

              <p className="text-gray-600 mt-6">
                Grow smarter, engage faster, and streamline your processes with
                Anlook's WhatsApp automation solutions!
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Buy Plan Details Screen */}
      {showBuyPlanDetails && !showTrialForm && selectedPlan && (
        <div className="vertical-height-100 gredient-bg min-h-screen flex justify-center items-center px-4">
          <div className="buyplandetails-container w-full max-w-2xl bg-white rounded-xl shadow-xl overflow-hidden">
            {/* Header */}
            <div className="buyplandetails-header bg-green-600 text-white text-center py-4 text-xl font-semibold">
              Plan Details
            </div>

            <div className="buyplandetails-content p-6 space-y-6">
              {/* Plan Name & Description */}
              <div>
                <p className="text-2xl font-bold text-gray-800">
                  {selectedPlan.plan_name}
                </p>
                <p className="text-gray-600 mt-2">{selectedPlan.plan_desc}</p>
              </div>

              {/* Pricing Section */}
              <div className="buyplandetails-pricing space-y-4 border rounded-lg p-4 bg-gray-50">
                <div className="buyplandetails-fee flex justify-between items-center">
                  <span className="text-gray-700 flex items-center gap-2">
                    Setup Fee
                    <small className="text-gray-500">(One-Time Fee)</small>
                    <img src={infoIcon} alt="icon" className="h-4 w-4" />
                  </span>
                  <span className="font-medium">
                    ₹ {parseFloat(selectedPlan.setup_fee).toFixed(2)}
                  </span>
                </div>

                <div className="buyplandetails-fee flex justify-between items-center">
                  <span className="text-gray-700">Plan Fee</span>
                  <span className="font-medium">
                    ₹ {parseFloat(selectedPlan.plan_price).toFixed(2)}/mo.
                  </span>
                </div>

                <div className="buyplandetails-total-fee flex justify-between items-center pt-3 border-t font-semibold text-lg">
                  <span>Total Fee</span>
                  <span>
                    ₹ {parseFloat(selectedPlan.total_price).toFixed(2)}
                  </span>
                </div>
              </div>

              {/* Features */}
              <div className="buyplandetails-features">
                <h3 className="text-lg font-semibold mb-3">Features</h3>

                <ul className="space-y-2">
                  {selectedPlan.features
                    .filter((feature) => feature.status === "Y")
                    .map((feature, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <img
                          src={greentick}
                          alt="check"
                          className="h-5 w-5 mt-1"
                        />
                        <span className="text-gray-700">
                          {feature.feature_name}
                        </span>
                      </li>
                    ))}
                </ul>
              </div>

              {/* Buttons */}
              <div className="buyplandetails-actions flex justify-between gap-4 pt-4">
                <button
                  className="buyplandetails-change-button w-1/2 border border-gray-400 text-gray-700 py-2 rounded-lg hover:bg-gray-100 transition"
                  onClick={closeBuyPlanDetails}
                >
                  Change Plan
                </button>

                <button
                  className="buyplandetails-proceed-button w-1/2 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
                  onClick={openBuyPlanForm}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Buy Plan Registration From Screen */}
      {showBuyPlanForm && !showTrialForm && !showBuyPlanDetails && (
        <div className="vertical-height-100 gredient-bg min-h-screen flex justify-center items-center px-4">
          <div className="buyplandetails-container w-full max-w-2xl bg-white rounded-xl shadow-xl overflow-hidden">
            <form onSubmit={handleBuyplanFormContinue}>
              {/* Header */}
              <div className="buyplandetails-header bg-green-600 text-white text-center py-4 text-xl font-semibold">
                Fill Your Details to Continue
              </div>

              <div className="buyplanRegistration-content p-6 space-y-6">
                {/* STEP 1 */}
                {buyplanFormStep === 1 && (
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div>
                      <label className="buyplan-label text-sm font-medium">
                        First Name
                      </label>
                      <input
                        type="text"
                        name="buyplanFirstName"
                        value={buyplanFormData.buyplanFirstName}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md focus:ring-2 focus:ring-green-500 outline-none"
                      />
                    </div>

                    <div>
                      <label className="buyplan-label text-sm font-medium">
                        Last Name
                      </label>
                      <input
                        type="text"
                        name="buyplanLastName"
                        value={buyplanFormData.buyplanLastName}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md focus:ring-2 focus:ring-green-500 outline-none"
                      />
                    </div>

                    <div className="lg:col-span-2">
                      <label className="buyplan-label text-sm font-medium">
                        Email
                      </label>
                      <input
                        type="email"
                        name="buyplanEmail"
                        value={buyplanFormData.buyplanEmail}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md focus:ring-2 focus:ring-green-500 outline-none"
                      />
                    </div>

                    <div>
                      <label className="buyplan-label text-sm font-medium">
                        Country
                      </label>
                      <select
                        name="countryCode"
                        value={buyplanFormData.countryCode}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md"
                      >
                        <option value="+91">+91</option>
                        <option value="+1">+1</option>
                      </select>
                    </div>

                    <div>
                      <label className="buyplan-label text-sm font-medium">
                        Mobile Number
                      </label>
                      <input
                        type="text"
                        name="mobileNo"
                        maxLength="10"
                        value={buyplanFormData.mobileNo}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md"
                      />
                    </div>

                    <div>
                      <label className="buyplan-label text-sm font-medium">
                        Date of Birth
                      </label>
                      <input
                        type="date"
                        name="buyplanDob"
                        value={buyplanFormData.buyplanDob}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md"
                      />
                    </div>

                    <div>
                      <label className="buyplan-label text-sm font-medium">
                        Gender
                      </label>
                      <select
                        name="buyplanGender"
                        value={buyplanFormData.buyplanGender}
                        onChange={handleBuyplanInputChange}
                        className="buyplan-input w-full mt-1 px-4 py-2 border rounded-md"
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                )}

                {/* STEP 2 */}
                {buyplanFormStep === 2 && (
                  <div className="space-y-4">
                    <h4 className="text-lg font-semibold">
                      Set up your password
                    </h4>

                    <input
                      type="password"
                      name="buyplanPassword"
                      placeholder="Password"
                      value={buyplanFormData.buyplanPassword}
                      onChange={handleBuyplanInputChange}
                      className="buyplan-input w-full px-4 py-2 border rounded-md"
                    />

                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="buyplanConfirmPassword"
                      placeholder="Confirm Password"
                      value={buyplanFormData.buyplanConfirmPassword}
                      onChange={handleBuyplanInputChange}
                      className="buyplan-input w-full px-4 py-2 border rounded-md"
                    />

                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={showConfirmPassword}
                        onChange={toggleShowConfirmPassword}
                      />
                      <span>Show Password</span>
                    </div>
                  </div>
                )}

                {/* STEP 3 */}
                {buyplanFormStep === 3 && (
                  <div className="space-y-4">
                    <h4 className="text-lg font-semibold">OTP Verification</h4>

                    <div className="text-gray-500 text-sm">
                      OTP has been Sent to {buyplanFormData.mobileNo}
                    </div>

                    <input
                      type="text"
                      name="otp"
                      placeholder="Please Enter OTP"
                      value={buyplanFormData.otp}
                      onChange={handleBuyplanInputChange}
                      className="buyplan-input w-full px-4 py-2 border rounded-md"
                    />
                  </div>
                )}

                {/* Buttons */}
                <div className="flex gap-4 pt-4">
                  {buyplanFormStep === 2 && (
                    <button
                      type="button"
                      onClick={handleBuyplanFormBack}
                      className="px-6 py-2 border border-gray-400 rounded-md hover:bg-gray-100 transition"
                    >
                      Back
                    </button>
                  )}

                  {buyplanFormStep !== 3 && (
                    <button
                      type="submit"
                      className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition"
                    >
                      {buyplanFormStep === 1 ? "Continue" : "Send OTP"}
                    </button>
                  )}

                  {buyplanFormStep === 3 && (
                    <button
                      type="button"
                      onClick={handleOTPVerification}
                      className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition"
                    >
                      Verify OTP
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default GetStarted;
